import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { NotificationType, User } from '@/models/user.model';
import usersService from '@/services/users.service';
import { Actions, ShiftCMSState } from '@/store';
import { PropType, reactive, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserNotifications',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState>();

const props = __props;

const showForm = ref<boolean>(false);
const showConfirmation = ref<boolean>(false);
const showError = ref<boolean>(false);

const notification = reactive({
  title: '',
  description: '',
});

async function sendNotification() {
  if (!showForm.value) {
    showForm.value = true;
    return;
  }
  if (confirm('are you sure you want to send this notification to the user?')) {
    const response = await usersService.sendNotification({
      userId: props.user.id,
      ...notification,
    });

    if (response.status) {
      notification.title = '';
      notification.description = '';
      showForm.value = false;
      showConfirmation.value = true;
      showError.value = false;
    } else {
      showForm.value = false;
      showError.value = true;
    }
  }

  setTimeout(() => {
    showForm.value = false;
    showConfirmation.value = false;
    showError.value = false;
  }, 5000);
}

async function testPopularInitiative() {
  if (
    confirm('are you sure you want to send this test notification to the user?')
  ) {
    await usersService.sendPopularTestNotification({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Notification sent`,
      type: 'success',
    });
  }
}

async function sendDiscountNotification() {
  if (
    confirm('are you sure you want to send this test notification to the user?')
  ) {
    await usersService.sendDiscountNotification({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Notification sent`,
      type: 'success',
    });
  }
}

async function sendPopularLearningItemNotification() {
  if (
    confirm('are you sure you want to send this test notification to the user?')
  ) {
    await usersService.sendPopularLearningItemNotification({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Notification sent`,
      type: 'success',
    });
  }
}

async function sendPopularNotification() {
  if (
    confirm('are you sure you want to send this test notification to the user?')
  ) {
    await usersService.sendPopularNotification({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Notification sent`,
      type: 'success',
    });
  }
}

async function sendQuizNotification() {
  if (
    confirm('are you sure you want to send this test notification to the user?')
  ) {
    await usersService.sendQuizNotification({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Notification sent`,
      type: 'success',
    });
  }
}

async function sendDiscountEmail() {
  if (confirm('are you sure you want to send this test email to the user?')) {
    await usersService.sendDiscountEmail({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Email sent`,
      type: 'success',
    });
  }
}

async function sendPopularEmail() {
  if (confirm('are you sure you want to send this test email to the user?')) {
    await usersService.sendPopularEmail({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Email sent`,
      type: 'success',
    });
  }
}

async function sendPopularLearningItemEmail() {
  if (confirm('are you sure you want to send this test email to the user?')) {
    await usersService.sendPopularLearningItemEmail({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Email sent`,
      type: 'success',
    });
  }
}

async function sendQuizEmail() {
  if (confirm('are you sure you want to send this test email to the user?')) {
    await usersService.sendQuizEmail({
      userId: props.user.id,
    });
    store.dispatch(Actions.ShowNotification, {
      message: `Email sent`,
      type: 'success',
    });
  }
}

function sendEmail(type: NotificationType) {
  switch (type) {
    case NotificationType.Discounts:
      return sendDiscountEmail();
    case NotificationType.PopulairInitiatives:
      return sendPopularEmail();
    case NotificationType.PopulairLearningItem:
      return sendPopularLearningItemEmail();
    case NotificationType.QuizStreak:
      return sendQuizEmail();
  }
}

function sendTestNotification(type: NotificationType) {
  switch (type) {
    case NotificationType.Discounts:
      return sendDiscountNotification();
    case NotificationType.PopulairInitiatives:
      return sendPopularNotification();
    case NotificationType.PopulairLearningItem:
      return sendPopularLearningItemNotification();
    case NotificationType.QuizStreak:
      return sendQuizNotification();
  }
}

const types = [
  NotificationType.Discounts,
  NotificationType.PopulairInitiatives,
  NotificationType.PopulairLearningItem,
  NotificationType.QuizStreak,
];

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (__props.user.id !== -1)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Notifications and Email Settings")
            ])),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("strong", null, "Type", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { align: "center" }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createElementVNode("strong", null, "Email", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { align: "center" }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createElementVNode("strong", null, "Test", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { align: "center" }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createElementVNode("strong", null, "Phone", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { align: "center" }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createElementVNode("strong", null, "Test", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(types, (type) => {
                return _createVNode(_component_v_row, {
                  dense: "",
                  key: type
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { alignSelf: "center" }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`user.notifications.${type.replace(/-/g, '_')}`)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_chip, { color: "primary" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.user.notificationSettings.find((t) => t.notificationType === type)
              ?.email
              ? _ctx.$t(`user.notifications.yes`)
              : _ctx.$t(`user.notifications.no`)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: ($event: any) => (sendEmail(type)),
                          density: "compact",
                          icon: "",
                          color: "info",
                          disabled: !__props.user.email
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-email" })
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_chip, { color: "primary" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.user.notificationSettings.find((t) => t.notificationType === type)
              ?.phone
              ? _ctx.$t(`user.notifications.yes`)
              : _ctx.$t(`user.notifications.no`)), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_col, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: ($event: any) => (sendTestNotification(type)),
                          density: "compact",
                          icon: "",
                          color: "info",
                          disabled: !(__props.user.enablePushNotifications && __props.user.expoPushToken)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-phone" })
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              }), 64)),
              (!(__props.user.enablePushNotifications && __props.user.expoPushToken))
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    class: "mt-4",
                    type: "warning"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("This user has no token or has notifications turned off.")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (showForm.value)
                ? (_openBlock(), _createBlock(_component_v_form, {
                    key: 1,
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        label: "Title",
                        modelValue: notification.title,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((notification.title) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        label: "Description",
                        modelValue: notification.description,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((notification.description) = $event)),
                        singleLine: false
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (showConfirmation.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 2,
                    class: "mb-4",
                    type: "success"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("The message was sent.")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (showError.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 3,
                    class: "mb-4",
                    type: "error"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("The message could not be sent")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.user.enablePushNotifications && __props.user.expoPushToken)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 4,
                    color: "info",
                    density: "compact",
                    onClick: sendNotification
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("Send notification")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (__props.user.enablePushNotifications && __props.user.expoPushToken)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 5,
                    class: "ml-4",
                    color: "info",
                    density: "compact",
                    onClick: testPopularInitiative
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("Test popular initiative")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})